import React, {useState} from 'react';
import {PlusOutlined} from '@ant-design/icons';
import {Button, Form, Modal, Row, Select} from 'antd';
import {createD365ExpenseMapping} from '../../api/d365Api';

const ExpenseMappingButton = ({
                                disabled,
                                onCompleted,
                                title,
                                email,
                                types,
                                codes,
                                style
                              }) => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [codeId, setCodeId] = useState([]);
  const [typeId, setTypeId] = useState([]);
  const [form] = Form.useForm();

  const _createExpenseMapping = async () => {
    try {
      setLoading(true);
      const response = await createD365ExpenseMapping(codeId, typeId, email);
      onCompleted(response, "created");
    } catch (e) {
      console.error(`Could not create Expense Mapping`);
    } finally {
      setLoading(false);
      setShowModal(false);
      form.resetFields();
      onCompleted(null, "");
    }
  };

  const handleCodeChange = (codeId) => {
    setCodeId(codeId)
  };

  const handleTypeChange = (typeId) => {
    setTypeId(typeId)
  };

  return (
    <>
      <Button onClick={() => setShowModal(true)} loading={loading} disabled={disabled}
              icon={<PlusOutlined/>} style={style}>
        {title}
      </Button>

      <Modal
        title={`Create expense mapping`}
        open={showModal}
        onOk={() => setShowModal(false)}
        onCancel={() => setShowModal(false)}
        footer={[
          <Button key="cancel" onClick={() => setShowModal(false)}>Cancel</Button>,
          <Button key="submit" type="primary" disabled={codeId.length <= 0 || typeId.length <= 0}
                  onClick={() => form.submit()}
                  loading={loading}>Submit</Button>
        ]}
      >
        <Form
          name={`input_expense_mapping`}
          form={form}
          onFinish={_createExpenseMapping}
          labelCol={{span: 6}}
        >
          <Row>
            {codes.length > 0 && (
              <Select
                showSearch
                mode="single"
                style={{flex: "auto"}}
                placeholder="Search to Select Code"
                optionFilterProp="children"
                onChange={handleCodeChange}
              >
                {codes.map(code => (
                  <Select.Option key={code.code} value={code.ID}>
                    {code.code}
                  </Select.Option>
                ))}
              </Select>
            )}

          </Row>
          <Row>
            {types.length > 0 && (
              <Select
                showSearch
                mode="single"
                style={{flex: "auto", marginTop: 10}}
                placeholder="Search to Select Type"
                optionFilterProp="children"
                onChange={handleTypeChange}
              >
                {types.map(type => (
                  <Select.Option key={type.name} value={type.ID}>
                    {type.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export {ExpenseMappingButton};